// Shared photo-pack covers for the landing page and app. Prompts and upload checksums: docs/assets/photo-pack-covers-2026-09-15/.
const coverRoot =
  'https://media.easy-peasy.ai/landing/photo-packs/covers-2026-09-15';

export const PHOTO_PACK_COVERS: Readonly<Partial<Record<string, string>>> = {
  halloween: `${coverRoot}/halloween.webp`,
  instagram: `${coverRoot}/instagram.webp`,
  'startup-founder': `${coverRoot}/startup-founder.webp`,
  'college-party': `${coverRoot}/college-party.webp`,
  'ai-avatars': `${coverRoot}/ai-avatars.webp`,
  'linkedin-headshots': `${coverRoot}/linkedin-headshots.webp`,
  'fitness-influencer': `${coverRoot}/fitness-influencer.webp`,
  tinder: `${coverRoot}/tinder.webp`,
  hinge: `${coverRoot}/hinge.webp`,
  'old-money': `${coverRoot}/old-money.webp`,
  'ai-photography': `${coverRoot}/ai-photography.webp`,
  'corporate-executive': `${coverRoot}/corporate-executive.webp`,
  'beach-vacation': `${coverRoot}/beach-vacation.webp`,
  'coffee-shop': `${coverRoot}/coffee-shop.webp`,
  'winter-wonderland': `${coverRoot}/winter-wonderland.webp`,
  'street-style': `${coverRoot}/street-style.webp`,
  'glamour-shots': `${coverRoot}/glamour-shots.webp`,
  'yoga-wellness': `${coverRoot}/yoga-wellness.webp`,
  'luxury-lifestyle': `${coverRoot}/luxury-lifestyle.webp`,
  'outdoor-adventure': `${coverRoot}/outdoor-adventure.webp`,
  'graduation-photos': `${coverRoot}/graduation-photos.webp`,
  'business-casual': `${coverRoot}/business-casual.webp`,
  'wedding-guest': `${coverRoot}/wedding-guest.webp`,
  'model-portfolio': `${coverRoot}/model-portfolio.webp`,
  'athleisure-style': `${coverRoot}/athleisure-style.webp`,
  'date-night': `${coverRoot}/date-night.webp`,
  'festival-vibes': `${coverRoot}/festival-vibes.webp`,
  'gamer-setup': `${coverRoot}/gamer-setup.webp`,
  'pet-lover': `${coverRoot}/pet-lover.webp`,
  entrepreneur: `${coverRoot}/entrepreneur.webp`,
  bumble: `${coverRoot}/bumble.webp`,
  'travel-adventure': `${coverRoot}/travel-adventure.webp`,
  'spring-vibes': `${coverRoot}/spring-vibes.webp`,
  'night-out': `${coverRoot}/night-out.webp`,
  'artist-creative': `${coverRoot}/artist-creative.webp`,
  'summer-fun': `${coverRoot}/summer-fun.webp`,
  'chef-foodie': `${coverRoot}/chef-foodie.webp`,
  'musician-performer': `${coverRoot}/musician-performer.webp`,
  'bookworm-reader': `${coverRoot}/bookworm-reader.webp`,
  'premium-portraits': `${coverRoot}/premium-portraits.webp`,
  'ai-influencer': `${coverRoot}/ai-influencer.webp`,
  'ai-nature-photos': `${coverRoot}/ai-nature-photos.webp`,
  'ai-keynote-speaker': `${coverRoot}/ai-keynote-speaker.webp`,
  'ai-beach-bikini': `${coverRoot}/ai-beach-bikini.webp`,
  'author-headshots': `${coverRoot}/author-headshots.webp`,
  'lawyer-headshots': `${coverRoot}/lawyer-headshots.webp`,
  'life-coach-headshots': `${coverRoot}/life-coach-headshots.webp`,
  '1950s-film-noir': `${coverRoot}/1950s-film-noir.webp`,
  'doctor-headshots': `${coverRoot}/doctor-headshots.webp`,
  cosplay: `${coverRoot}/cosplay.webp`,
  swimsuit: `${coverRoot}/swimsuit.webp`,
  'real-estate-agent-headshots': `${coverRoot}/real-estate-agent-headshots.webp`,
  cheerleader: `${coverRoot}/cheerleader.webp`,
  'podcast-host-studio': `${coverRoot}/podcast-host-studio.webp`,
  'mob-wife': `${coverRoot}/mob-wife.webp`,
  mobster: `${coverRoot}/mobster.webp`,
  'retro-80s': `${coverRoot}/retro-80s.webp`,
  'retro-90s': `${coverRoot}/retro-90s.webp`,
  'y2k-aesthetic': `${coverRoot}/y2k-aesthetic.webp`,
  'puffer-jacket': `${coverRoot}/puffer-jacket.webp`,
  cyberpunk: `${coverRoot}/cyberpunk.webp`,
  'therapist-headshots': `${coverRoot}/therapist-headshots.webp`,
  yearbook: `${coverRoot}/yearbook.webp`,
  'flight-attendant': `${coverRoot}/flight-attendant.webp`,
  catgirl: `${coverRoot}/catgirl.webp`,
  'fashion-week': `${coverRoot}/fashion-week.webp`,
  musicians: `${coverRoot}/musicians.webp`,
  'latex-glossy': `${coverRoot}/latex-glossy.webp`,
  'ai-girlfriend': `${coverRoot}/ai-girlfriend.webp`,
  christmas: `${coverRoot}/christmas.webp`,
  'day-of-the-dead': `${coverRoot}/day-of-the-dead.webp`,
  'valentines-day': `${coverRoot}/valentines-day.webp`,
  easter: `${coverRoot}/easter.webp`,
  wedding: `${coverRoot}/wedding.webp`,
  'new-years-eve': `${coverRoot}/new-years-eve.webp`,
  'fairy-tale': `${coverRoot}/fairy-tale.webp`,
  'chinese-new-year': `${coverRoot}/chinese-new-year.webp`,
  hanukkah: `${coverRoot}/hanukkah.webp`,
  'summer-in-paris': `${coverRoot}/summer-in-paris.webp`,
  'summer-in-tokyo': `${coverRoot}/summer-in-tokyo.webp`,
  'retro-1950s-diner': `${coverRoot}/retro-1950s-diner.webp`,
  'passport-photos': `${coverRoot}/passport-photos.webp`,
  diwali: `${coverRoot}/diwali.webp`,
};
